export const safeNumber = (n: number | undefined | null): number => {
  if (n === undefined || n === null) {
    return 0;
  }

  if (isNaN(n)) {
    return 0;
  }

  return n;
};
